export const TRIAL_FORM_ID = 1246;
export const DEMO_FORM_ID = 1265;
export const SALES_FORM_ID = 1262;
export const TALK_SALES_FORM_ID = 2407;
export const PARTNERSHIPS_FORM_ID = 2411;
export const NEW_PARTNERSHIPS_FORM_ID = 2495;
